export default "__VITE_ASSET__bb5365c2__"